<template>
  <div>
    <a-row>
      <a-col :span="24">
        <div class="top">
          <span class="a-span">角色名称：</span>
          <a-input
            class="a-input"
            v-model="roleName"
            placeholder="请输入角色名称"
          ></a-input>
          <span class="b-span">角色描述：</span>
          <a-textarea
            v-model="roleDesc"
            class="a-textarea"
            placeholder="请输入角色描述"
            :rows="4"
          />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="top" style="height: auto;">
          <a-tree
            class="tree"
            :checked-keys="checkedKeys"
            checkable
            :check-strictly="true"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="ywArr"
            @expand="onExpand"
            @select="onSelect"
            @check="onCheck"
            :replaceFields="{ children: 'children' }"
          />
        </div>
      </a-col>
    </a-row>
    <div class="s-button">
      <a-button @click="save">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import {
  storePermissionsListAdd,
  storePermissionsListCreate,
  storePermissionsListDetails,
  storePermissionsListEdit,
  getRoleMenuByRoleId
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const ywArr = [];
const xmArr = [];
const treeData = [
  {
    title: "0-0-0-1",
    key: "0-0",
    children: [
      {
        title: "0-0-0",
        key: "0-0-0",
      },
      {
        title: "0-0-1",
        key: "0-0-1",
        children: [
          { title: "0-0-1-0", key: "0-0-1-0" },
          { title: "0-0-1-1", key: "0-0-1-1" },
          { title: "0-0-1-2", key: "0-0-1-2" },
        ],
      },
      {
        title: "0-0-2",
        key: "0-0-2",
      },
    ],
  },
  {
    title: "0-1",
    key: "0-1",
    children: [
      { title: "0-1-0-0", key: "0-1-0-0" },
      { title: "0-1-0-1", key: "0-1-0-1" },
      { title: "0-1-0-2", key: "0-1-0-2" },
    ],
  },
  {
    title: "0-2",
    key: "",
  },
  {
    title: "0-3",
    key: "",
  },
  {
    title: "0-4",
    key: "",
  },
  {
    title: "0-5",
    key: "",
  },
  {
    title: "0-6",
    key: "",
  },
  {
    title: "0-7",
    key: "",
  },
  {
    title: "0-8",
    key: "",
  },
  {
    title: "0-9",
    key: "",
  },
  {
    title: "0-10",
    key: "",
  },
];
export default {
  data() {
    return {
      treeData,
      expandedKeys: ["0-0-0", "0-0-1"],
      autoExpandParent: true,
      checkedKeys: [],//开始赋值默认值
      selectedKeys: [],
      xmArr,
      ywArr,
      menuIdList: [],
      roleName: "",
      roleDesc: "",
    };
  },
  watch: {
    checkedKeys(val) {
      console.log("onCheck", val);
    },
  },
  mounted() {
    this.getStorePermissionsListAdd();
    this.getStorePermissionsListDetails();
    this.getRoleMenuByRoleId();
  },
  methods: {
    setName(datas){ //遍历树  获取 id 数组
      for(var i in datas){
        if(datas[i].select){
          this.checkedKeys.push(datas[i].objId)  // 遍历项目满足条件后的操作
        }
        if(datas[i].children){  //存在子节点就递归
          this.setName(datas[i].children);
        }
      }
    },
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      console.log("onCheck before process", checkedKeys);
      // 处理 checkedKeys 可能是对象的情况（注意字段名是 checked 而不是 checkedKeys）
      const keys = Array.isArray(checkedKeys) ? checkedKeys : (checkedKeys.checked || []);
      // console.log("提取出的 keys:", keys);
      
      // 处理选中逻辑：如果只选择二级目录，需要把一级目录的 id 加上
      const finalCheckedKeys = this.processCheckedKeys(keys);
      console.log("onCheck after process", finalCheckedKeys);
      this.checkedKeys = finalCheckedKeys;
      this.menuIdList = finalCheckedKeys;
    },
    processCheckedKeys(checkedKeys) {
      // console.log("processCheckedKeys 输入:", checkedKeys);
      
      // 创建树形结构的映射，用于查找父子关系
      const treeMap = new Map();
      
      // 遍历 ywArr 构建树形映射
      this.ywArr.forEach(parent => {
        treeMap.set(parent.key, parent);
        if (parent.children && parent.children.length > 0) {
          parent.children.forEach(child => {
            treeMap.set(child.key, { ...child, parentId: parent.key });
          });
        }
      });
      
      // console.log("treeMap 大小:", treeMap.size);
      // console.log("ywArr 长度:", this.ywArr.length);
      
      // 保存 treeMap 供其他方法使用
      this.treeMap = treeMap;
      
      const resultKeys = new Set(checkedKeys);
      
      // 遍历所有选中的 key
      checkedKeys.forEach(key => {
        // console.log("处理 key:", key);
        const node = treeMap.get(key);
        // console.log("node:", node);
        // 如果节点有 parentId，说明是二级目录，需要添加一级目录的 id
        if (node && node.parentId) {
          // console.log("添加父节点 ID:", node.parentId);
          resultKeys.add(node.parentId);
        }
      });
      
      const result = Array.from(resultKeys);
      console.log("processCheckedKeys 输出:", result);
      return result;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    // 明细
    getStorePermissionsListDetails() {
      let roleId = this.$route.query.id;
      storePermissionsListDetails(roleId).then((res) => {
        this.roleName = res.data.roleName;
        this.roleDesc = res.data.roleDesc;
      });
    },
    getStorePermissionsListAdd() {
      storePermissionsListAdd().then((res) => {
        this.setName(res.data)
        res.data.map((item) => {
          this.ywArr.push({
            title: item.name,
            key: item.objId,
            children: this.loop(item.children),
          });
        });
        console.log("树形数据 ywArr 加载完成:", this.ywArr);
        
        // 树形数据加载完成后，再获取角色权限
        this.$nextTick(() => {
          this.getRoleMenuByRoleId();
        });
      });
    },
    getRoleMenuByRoleId() {
      let roleId = this.$route.query.id;
      getRoleMenuByRoleId(roleId).then(res => {
        console.log("getRoleMenuByRoleId 完整响应:", res);
        console.log("getRoleMenuByRoleId 响应 data:", res.data);
        console.log("getRoleMenuByRoleId 响应 data 类型:", typeof res.data, Array.isArray(res.data));
        
        // 处理后端返回的数据结构
        let backendCheckedKeys = [];
        
        // 尝试从不同位置获取 menuIdList
        if (Array.isArray(res.data)) {
          backendCheckedKeys = res.data;
        } else if (res.data) {
          // 如果 data 是对象，尝试从不同字段获取
          if (Array.isArray(res.data.menuIdList)) {
            backendCheckedKeys = res.data.menuIdList;
          } else if (Array.isArray(res.data.checkedKeys)) {
            backendCheckedKeys = res.data.checkedKeys;
          } else if (Array.isArray(res.data.menus)) {
            backendCheckedKeys = res.data.menus;
          } else if (Array.isArray(res.data.list)) {
            backendCheckedKeys = res.data.list;
          }
        }
        
        // console.log("后端返回的选中 ID:", backendCheckedKeys);
        // console.log("后端返回的选中 ID 类型:", typeof backendCheckedKeys, Array.isArray(backendCheckedKeys));
        // console.log("后端返回的选中 ID 长度:", backendCheckedKeys.length);
        
        if (backendCheckedKeys.length === 0) {
          console.warn("警告：后端没有返回任何选中的菜单 ID!");
        }
        
        // 直接使用后端返回的所有 ID 进行勾选显示
        this.checkedKeys = backendCheckedKeys;
        console.log("设置后的 this.checkedKeys:", this.checkedKeys);
      });
    },
    loop(item) {
      if (item !== null) {
        console.log(item, "item ==> 不为null");
        let arr = [];
        item.forEach((item) => {
          arr.push({
            title: item.name,
            key: item.objId,
          });
        });
        return arr;
      }
    },
    save() {
      // 在保存前再次确保处理了父子节点关系
      // 处理 checkedKeys 可能是对象的情况
      let keys;
      if (Array.isArray(this.checkedKeys)) {
        keys = this.checkedKeys;
      } else if (this.checkedKeys && Array.isArray(this.checkedKeys.checked)) {
        keys = this.checkedKeys.checked;
      } else if (this.checkedKeys && Array.isArray(this.checkedKeys.checkedKeys)) {
        keys = this.checkedKeys.checkedKeys;
      } else {
        keys = [];
      }
      
      // console.log("原始选中的 keys:", keys);
      
      const finalCheckedKeys = this.processCheckedKeys(keys);
      // console.log("处理后的 menuIdList:", finalCheckedKeys);
      // console.log("menuIdList 类型:", typeof finalCheckedKeys, Array.isArray(finalCheckedKeys));
      
      let id = this.$route.query.id;
      let obj = {
        id: id,
        isShop: 1,
        roleName: this.roleName,
        roleDesc: this.roleDesc,
        menuIdList: finalCheckedKeys,
      };
      // console.log("提交到后端的完整数据:", obj);
      // console.log("menuIdList 是否为空:", finalCheckedKeys.length === 0);
      
      if (this.roleName.trim() !== "") {
        if (finalCheckedKeys.length === 0) {
          message.warning("请至少选择一个菜单项");
          return;
        }
        
        storePermissionsListEdit(obj).then((res) => {
          message.success(res.info);
          this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
          location.reload();
        });
      } else {
        message.warning("角色描述不可为空");
      }
    },
    goBack() {
      this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
      location.reload();
    },
  },
};
</script>

<style scoped>
.s-button {
  margin-left: 20px;
}
.tree {
  position: relative;
  left: 160px;
}
.a-span {
  position: relative;
  left: 80px;
  top: 25px;
}
.b-span {
  position: relative;
  top: 75px;
  left: 80px;
}
.a-input {
  position: relative;
  left: 160px;
  display: block;
  width: 350px;
}
.a-textarea {
  position: relative;
  left: 160px;
  top: 50px;
  display: block;
  width: 450px;
}
.top {
  margin: 15px;
  height: 400px;
  background-color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/views/right/partManagementTwo/EditpartManagementTwo/EditpartManagementTwo.vue